import { useContext, useState } from 'react'
import { IconButton, TextInput } from 'ui'
import { TextStyle } from '../../../../types'
import { DEFAULT_CAPTION_STYLE } from '../../constants'
import { UGEContext } from '../../context'
import { getCaptionLayer } from '../../utilities/layer'
import { TextStyler } from './style'

type Props = {
    className?: string
    placeholder: string
    onAdd?: (layerId: string) => void
}

const UGECaptionsEditorAddCaption = ({ className, placeholder, onAdd: onAddProp }: Props) => {
    const { crop, dimensions, addLayer, trackGAEvent } = useContext(UGEContext)
    const [style, setStyle] = useState<TextStyle>(DEFAULT_CAPTION_STYLE)
    const [text, setText] = useState<string>('')

    function onAdd() {
        if (!text) return

        const layer = getCaptionLayer(text, dimensions, style, crop)

        addLayer(layer)
        setText('')
        onAddProp?.(layer.id)

        trackGAEvent('creation_caption_add')
    }

    function onStyleChange(props: Partial<TextStyle>) {
        setStyle({ ...style, ...props })
    }

    return (
        <div className={className}>
            <TextInput autoFocus multiline placeholder={placeholder} size="medium" value={text} onChange={setText}>
                <IconButton
                    disabled={!text}
                    gradient={text ? 'indigo-purple' : undefined}
                    icon="add"
                    size="medium"
                    onClick={onAdd}
                />
            </TextInput>
            <TextStyler buttonColor="#000" textStyle={style} onChange={onStyleChange} />
        </div>
    )
}

export default UGECaptionsEditorAddCaption
